export default {
  rank: 99,
  color: '#C2C2C2',
};
